import { render, staticRenderFns } from "./TestFileUpload.vue?vue&type=template&id=488db668&scoped=true"
import script from "./TestFileUpload.vue?vue&type=script&lang=js"
export * from "./TestFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488db668",
  null
  
)

export default component.exports